// extracted by mini-css-extract-plugin
export default {"langsNav":"Langs_langsNav__GAwbD"};